export class Player {
    constructor(playerDTO) {
        this.username = playerDTO.username;
        this.position = playerDTO.position;
        this.size = playerDTO.size;
    }
    toDto() {
        return {
            username: this.username,
            position: this.position,
            size: this.size
        };
    }
}
